'use client';

import { useState } from 'react';

// Components
import SkeletonListListing from '@src/components/atoms/skeleton-list-listing';
import CardPropertySlider from '@src/components/atoms/card-property-slider';
import Button from '@src/components/atoms/button';

const DummyList = new Array(32).fill(null);

const LoaderSkeleton = () => {
  return (
    <>
      {DummyList.map((_, i) => {
        return <SkeletonListListing key={`skeleton-property-location-${i}`} />;
      })}
    </>
  );
};

const ListProperty = ({
  data,
  isFetchingNextPage,
  hasNextPage,
  isLoading,
  fetchNextPage,
  showButtonHubungkan = true,
  showUserName = true,
  showCompany = true,
  showUserInfo = true,
  idMarketing,
}) => {
  const [openModal, setOpenModal] = useState('');

  return (
    <div>
      <div
        className="grid grid-cols-4 gap-x-4 gap-y-[40px] 
    dd2-2xl:grid-cols-3 
    dd2-xl:grid-cols-2 dd2-xl:gap-y-4
    dd2-lg:grid-cols-1"
      >
        {!!data?.length &&
          data.map((list, index) => {
            return (
              <CardPropertySlider
                href={`/marketing/${idMarketing}/detail-listing/${list.slug}`}
                key={`marketing-list-listing-property-${list.id}-${index}`}
                openModal={openModal}
                setOpenModal={setOpenModal}
                showButtonHubungkan={showButtonHubungkan}
                showUserName={showUserName}
                showCompany={showCompany}
                showUserInfo={showUserInfo}
                priority={index < 4}
                {...list}
              />
            );
          })}
        {isLoading || (isFetchingNextPage && <LoaderSkeleton />)}
      </div>
      {hasNextPage && (
        <Button onClick={fetchNextPage} className="mx-auto my-4 bg-white border border-[#252526] !text-[#252526] border-solid rounded-[8px]" >
          Tampilkan Lebih Banyak
        </Button>
      )}
    </div>
  );
};

export default ListProperty;
